import React from "react";
import "./navbar.css";
import logoConexs from '../assets/icono/logo192Negativo.png';

function Navbar() {
  const handleScrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "center", // Centra la sección en el viewport
      });
    }
  };

  return (
    <div className="content-navbar">
      <div className="navbar">
        <div className="box-list-1">
          {/* Logo */}
          <a href="/" className="navbar-logo-link">
            <img src={logoConexs} alt="Logo Conexs" className="navbar-logo" />
          </a>
          <ul className="list">
            {/* Enlaces a las secciones */}
            <li className="box-list">
              <a
                className="navbar-link"
                onClick={() => handleScrollToSection("nosotros")}
              >
                Nosotros
              </a>
              <div className="line-navbar"></div>
            </li>
            <li className="box-list">
              <a
                className="navbar-link"
                onClick={() => handleScrollToSection("beneficios")}
              >
                Beneficios
              </a>
              <div className="line-navbar"></div>
            </li>
            <li className="box-list">
              <a
                className="navbar-link"
                onClick={() => handleScrollToSection("como-funciona")}
              >
                Cómo Funciona
              </a>
              <div className="line-navbar"></div>
            </li>
            <li className="box-list">
              <a
                className="navbar-link"
                onClick={() => handleScrollToSection("comienza")}
              >
                Comenzar
              </a>
              <div className="line-navbar"></div>
            </li>
          </ul>
        </div>
        {/* Registrarse e Iniciar Sesión */}
        <div className="box-list-2">
          <ul className="list-2">
            <li className="box-list">
              <a
                className="button-registrate-navbar"
                href="https://business.conexs.app/registrate"
                target="_blank"
                rel="noopener noreferrer"
              >
                Registrarse
              </a>
              <div className="line-navbar"></div>
            </li>
            <li className="box-list">
              <a
                className="button-login-navbar"
                href="https://business.conexs.app/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Iniciar sesión
              </a>
              <div className="line-navbar"></div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
